export class ConfiguracionReto {

  _id:    string;
  area: string;
  fechaInicio: Date;
  fechaFin: Date;
  intervaloTiempo: number;
  nombre: string;
  preguntasRonda: number;
}

export class Horario {
  fecha: Date;
}

export class Reto {

  _id:    string;
  activo: boolean;
  puntajeMaximoIndividual: number;
  horarios: Array<Horario>;
  configuracion: ConfiguracionReto;

  constructor() {
    this.horarios = [];
    this.configuracion = new ConfiguracionReto;
  }
}



// WEBPACK FOOTER //
// ./src/dominio/reto.ts